import { render, staticRenderFns } from "./modal_unit_form.vue?vue&type=template&id=70cec968&scoped=true"
import script from "./modal_unit_form.vue?vue&type=script&lang=js"
export * from "./modal_unit_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cec968",
  null
  
)

export default component.exports